// extracted by mini-css-extract-plugin
module.exports = {"container":"_18puDLVuD7f7UBzBPFWiZp","visible":"_3V8FZiFWPaVeK4dF_0nvkx","cancelBtn":"gJQEgRDXJoOTQRiwxrxf7","icon":"_1hV5qUnHg3Wco9_pX-U08Q","saveBtn":"Yj5g-QETPVv135maBVyvE"};